import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_gem-catalogue/artifacts/nrqp6drv_Untitled%20design-9.png";

export default function Footer() {
  return (
    <footer className="dark-surface mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        {/* Col 1 — Brand */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Bholaa Jewels" className="h-12 w-12 object-contain flex-shrink-0" />
            <div className="min-w-0">
              <div className="font-brand text-xl lg:text-2xl text-ivory whitespace-nowrap" style={{ fontWeight: 700, letterSpacing: '0.04em' }}>BHOLAA JEWELS</div>
              <div className="overline text-gold mt-1">Est. 1966</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: '#A8D5F2' }}>
            A house of fine gold and certified diamond jewellery, hand-finished in
            Chandigarh and quietly handed down for sixty years.
          </p>
          <div className="aspect-video rounded-sm overflow-hidden border border-gold/40 mt-4" data-testid="footer-map">
            <iframe
              title="Bholaa Jewels — SCO 33, Sector 8-B, Chandigarh"
              src="https://www.google.com/maps?q=SCO+33,+Sector+8B,+Chandigarh&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="w-full h-full border-0"
            />
          </div>
        </div>

        {/* Col 2 — Quick links */}
        <div>
          <h4 className="font-display text-lg text-gold-light mb-5" style={{ fontWeight: 600, letterSpacing: '0.06em' }}>Discover</h4>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li><Link to="/" className="hover:text-gold transition-colors" data-testid="footer-home">Home</Link></li>
            <li><Link to="/catalogue" className="hover:text-gold transition-colors" data-testid="footer-catalogue">The Catalogue</Link></li>
            <li><Link to="/ringstudio" className="hover:text-gold transition-colors" data-testid="footer-ringstudio">Ringstudio</Link></li>
            <li><Link to="/ai-tools" className="hover:text-gold transition-colors" data-testid="footer-ai-tools">AI Tools</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors" data-testid="footer-about">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        {/* Col 3 — Collections */}
        <div>
          <h4 className="font-display text-lg text-gold-light mb-5" style={{ fontWeight: 600, letterSpacing: '0.06em' }}>Collections</h4>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li><Link to="/catalogue?has_diamond=true" className="hover:text-gold transition-colors">Solitaires & Diamonds</Link></li>
            <li><Link to="/catalogue?has_diamond=false" className="hover:text-gold transition-colors">Gold Classics</Link></li>
            <li><Link to="/catalogue?karat=22kt" className="hover:text-gold transition-colors">22kt Heritage</Link></li>
            <li><Link to="/catalogue?karat=18kt" className="hover:text-gold transition-colors">18kt Modern</Link></li>
            <li><Link to="/ringstudio" className="hover:text-gold transition-colors">Ringstudio Collection</Link></li>
            <li><Link to="/catalogue?category=DIAMOND+PANDENT" className="hover:text-gold transition-colors">Bridal & Heirloom</Link></li>
          </ul>
        </div>

        {/* Col 4 — Contact */}
        <div>
          <h4 className="font-display text-lg text-gold-light mb-5" style={{ fontWeight: 600, letterSpacing: '0.06em' }}>Visit · Call · Write</h4>
          <ul className="space-y-4 text-sm text-ivory/75">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" /><span>SCO 33, Sector 8-B<br />Chandigarh — 160 009</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" /><a href="tel:+917814854580" className="hover:text-gold">+91 78148 54580</a></li>
            <li className="flex gap-3"><MessageCircle className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" /><a href="https://wa.me/917814854580" target="_blank" rel="noreferrer" className="hover:text-gold">WhatsApp</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" /><a href="mailto:bholaajewels@gmail.com" className="hover:text-gold">bholaajewels@gmail.com</a></li>
          </ul>
          <div className="mt-6 overline text-ivory/50">Mon — Sat · 10:30 AM – 8:00 PM</div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-gold/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-wrap items-center justify-between gap-4 text-[11px] tracking-wider text-ivory/55">
          <div>© 2025 Bholaa Jewels. Prices are indicative and subject to change with daily gold rates.</div>
          <div className="flex gap-5 text-gold/80">
            <span>BIS Hallmarked</span>
            <span>Certified Diamonds</span>
            <span>Transparent Pricing</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
